import { RewardProgramFragment } from '@graphql/fragments/__generated__/RewardProgram.generated'
import CloseIcon from '@mui/icons-material/Close'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { IconButton } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import makeStyles from '@mui/styles/makeStyles'
import React, { useState } from 'react'
import { isWebpSupported } from 'react-image-webp/dist/utils'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  rewardProgramWrapper: {
    display: 'flex',
    cursor: 'pointer',
    color: '#9a9a9a',
    height: 31,
  },
  rewardImg: {
    width: 80,
    height: 31,
    maxWidth: '100%',
    marginRight: '5px',
  },
  dialogContent: {
    '& img': {
      maxWidth: '100%',
      height: 'auto !important',
    },
  },
}))

interface RewardProgramButtonProps {
  rewardProgram: RewardProgramFragment | null
}

const RewardProgramButton: React.FC<RewardProgramButtonProps> = ({ rewardProgram }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [rewardProgramDialogIsOpen, setRewardProgramDialogIsOpen] = useState(false)
  if (!rewardProgram) return null
  return (
    <>
      <span className={classes.rewardProgramWrapper} onClick={() => setRewardProgramDialogIsOpen(true)}>
        <img
          className={classes.rewardImg}
          src={rewardProgram.thumbnailUrl}
          alt={rewardProgram.name}
        />
        <HelpOutlineOutlinedIcon />
      </span>
      <Dialog open={rewardProgramDialogIsOpen} onClose={() => setRewardProgramDialogIsOpen(false)}>
        <DialogTitle>
          <span className='inline-block' />
          <span className='absolute right-10 top-10'>
            <IconButton onClick={() => setRewardProgramDialogIsOpen(false)} size='medium' title={t('close', 'Close')}>
              <CloseIcon fontSize='large' />
            </IconButton>
          </span>
        </DialogTitle>

        <DialogContent className='w-600 max-w-full' dividers>
          <div className={classes.dialogContent} dangerouslySetInnerHTML={{ __html: rewardProgram.description }} />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default RewardProgramButton
